import React, { Component } from 'react';

import { TextField } from 'react-md';
import moment from 'moment';

import GoalContestManager from '../../managers/GoalContestManager';
import ZSelectField from '../Utility/ZSelectField';

export default class GoalsViewNew extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            slideNumber: 0,
            fromYear: null,
            fromMonth: null,
            fromDay: null,
            toYear: null,
            toMonth: null,
            toDay: null
        }

        // Variables
        this.gcManager = new GoalContestManager();

        // Methods
        this.validateForm = this.validateForm.bind(this);
        this.validateFormFinal = this.validateFormFinal.bind(this);
        this.selectScope = this.selectScope.bind(this);
        this.selectLocation = this.selectLocation.bind(this);
        this.selectUser = this.selectUser.bind(this);
        this.changeName = this.changeName.bind(this);
        this.changeDescription = this.changeDescription.bind(this);
        this.selectMetric = this.selectMetric.bind(this);
        this.selectHighLow = this.selectHighLow.bind(this);
        this.selectType = this.selectType.bind(this);
        this.changeValue = this.changeValue.bind(this);
        this.changeTimePeriod = this.changeTimePeriod.bind(this);

        this.selectFromYear = this.selectFromYear.bind(this);
        this.selectFromMonth = this.selectFromMonth.bind(this);
        this.selectFromDay = this.selectFromDay.bind(this);
        this.selectToYear = this.selectToYear.bind(this);
        this.selectToMonth = this.selectToMonth.bind(this);
        this.selectToDay = this.selectToDay.bind(this);

        this.generateSlides = this.generateSlides.bind(this);

        this.setSlide = this.setSlide.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.backSlide = this.backSlide.bind(this);
        this.cancel = this.cancel.bind(this);
        this.finish = this.finish.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    validateForm() {
        let isValid = true;

        let gForm = this.props.newGoalForm;
        let slide = this.state.slideNumber;

        if (slide >= 0 && gForm.scope === null) {
            isValid = false;
        }
        if (slide >= 1 &&
            (
                (gForm.scope === 'Location' && gForm.locationId === null) ||
                (gForm.scope === 'User' && (gForm.locationId === null || gForm.userId === null))
            )
        ) {
            isValid = false;
        }
        if (slide >= 2 && (gForm.name === null || gForm.name.trim() === '' || gForm.description === null || gForm.description.trim() === '')) {
            isValid = false;
        }
        if (slide >= 3 && (gForm.reportKPIId === null || gForm.useUnder === null || gForm.type === null ||
            !(gForm.value.trim() != '' && (gForm.value.match(/^\d+\.\d+$/) || gForm.value.match(/^-{0,1}\d+$/)))
        )) {
            isValid = false;
        }
        if (slide >= 4 && (gForm.timeFrame === null || gForm.fromDate === null || gForm.toDate === null)) {
            isValid = false;
        }

        return isValid;
    }

    validateFormFinal() {

        let gForm = this.props.newGoalForm;

        return (gForm.scope != null && gForm.clientAccountId != null && gForm.clientAccountId != '' &&
            (
                (gForm.scope === 'ClientAccount') ||
                (gForm.scope === 'Location' && gForm.locationId != null) ||
                (gForm.scope === 'User' && gForm.locationId != null && gForm.userId != null)
            ) &&
            gForm.name != null && gForm.name.trim() != '' && gForm.description != null && gForm.description.trim() != '' &&
            gForm.reportKPIId != null && gForm.useUnder != null && gForm.type != null &&
            gForm.value.trim() != '' && (gForm.value.match(/^\d+\.\d+$/) || gForm.value.match(/^-{0,1}\d+$/)) &&
            gForm.timeFrame != null && gForm.fromDate != null && gForm.toDate != null
        );
    }

    selectScope(scope) {
        let newGoalForm = this.props.newGoalForm;
        if ((scope === 'ClientAccount' || scope === 'Location' || scope === 'User') && scope != newGoalForm.scope) {
            if ((scope === 'User' && newGoalForm.scope != 'User') || (scope != 'User' && newGoalForm.scope === 'User')) {
                newGoalForm.reportKPIId = null;
                newGoalForm.useUnder = null;
                newGoalForm.type = null;
                newGoalForm.value = '';
            }
            newGoalForm.scope = scope;
            if (scope === 'ClientAccount') {
                newGoalForm.locationId = null;
                newGoalForm.userId = null;
            } else if (scope === 'Location') {
                newGoalForm.userId = null;
            }
            this.props.editNewGoal(newGoalForm);
        }
    }

    selectLocation(locationName) {
        let locationMap = this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
            let key = e.name;
            if (!r[key]) {
                r[key] = e.locationID;
            }
            return r;
        }, {});
        let locationId = locationMap[locationName];
        let newGoalForm = this.props.newGoalForm;
        if (locationId != newGoalForm.locationId) {
            newGoalForm.locationId = locationId;
            newGoalForm.userId = null;
            this.props.editNewGoal(newGoalForm);
        }
    }

    selectUser(userName) {
        let userMap = this.props.users.reduce((r, e) => {
            let key = e.fullName;
            if (!r[key]) {
                r[key] = e.userId;
            }

            return r;
        }, {});
        let userId = userMap[userName];
        let newGoalForm = this.props.newGoalForm;
        if (userId != newGoalForm.userId) {
            newGoalForm.userId = userId;
            this.props.editNewGoal(newGoalForm);
        }
    }

    changeName(name, e) {
        let newGoalForm = this.props.newGoalForm;
        if (name != newGoalForm.name) {
            newGoalForm.name = name;
            this.props.editNewGoal(newGoalForm);
        }
    }

    changeDescription(description, e) {
        let newGoalForm = this.props.newGoalForm;
        if (description != newGoalForm.description) {
            newGoalForm.description = description;
            this.props.editNewGoal(newGoalForm);
        }
    }

    selectMetric(metricName) {
        let newGoalForm = this.props.newGoalForm;
        let kpiMap = this.props.reportKPIs.reduce((r, e) => {
            let key = e.name;
            if (!r[key] && ((newGoalForm.scope === 'User' && e.kpiType === 'BLASTP') || (newGoalForm.scope != 'User' && e.kpiType === 'BLAST'))) {
                r[key] = e.reportKpiId;
            }

            return r;
        }, {});
        let kpiId = kpiMap[metricName];
        if (kpiId != newGoalForm.reportKPIId) {
            newGoalForm.reportKPIId = kpiId;
            this.props.editNewGoal(newGoalForm);
        }
    }

    selectHighLow(highLow) {
        let newGoalForm = this.props.newGoalForm;
        if (highLow != newGoalForm.useUnder) {
            newGoalForm.useUnder = highLow;
            this.props.editNewGoal(newGoalForm);
        }
    }

    selectType(type) {
        let newGoalForm = this.props.newGoalForm;
        if (type != newGoalForm.type) {
            newGoalForm.type = type;
            this.props.editNewGoal(newGoalForm);
        }
    }

    changeValue(value, e) {
        let newGoalForm = this.props.newGoalForm;
        if (value != newGoalForm.value) {
            newGoalForm.value = value;
            this.props.editNewGoal(newGoalForm);
        }
    }

    changeTimePeriod(timeFrame) {
        let self = this;
        let newGoalForm = this.props.newGoalForm;
        if (timeFrame != newGoalForm.timeFrame) {
            this.setState({
                fromYear: null,
                fromMonth: null,
                fromDay: null,
                toYear: null,
                toMonth: null,
                toDay: null
            }, () => {
                newGoalForm.timeFrame = timeFrame;
                newGoalForm.fromDate = null;
                newGoalForm.toDate = null;
                self.props.editNewGoal(newGoalForm);
            });
        }
    }

    selectFromYear(year) {
        let self = this;
        let fromMonthList = year != null ? Object.keys(this.props.calendarDates[this.props.newGoalForm.timeFrame.toLowerCase()].start[year]) : [];
        let fromDayList = [];
        if (fromMonthList.length === 1) {
            fromDayList = this.props.calendarDates[this.props.newGoalForm.timeFrame.toLowerCase()].start[year][fromMonthList[0]];
        }
        this.setState({
            fromYear: year,
            fromMonth: fromMonthList.length === 1 ? fromMonthList[0] : null,
            fromDay: fromMonthList.length === 1 && fromDayList.length === 1 ? fromDayList[0] : null,
            toYear: null,
            toMonth: null,
            toDay: null
        }, () => {
            let newGoalForm = self.props.newGoalForm;
            newGoalForm.fromDate = fromMonthList.length === 1 && fromDayList.length === 1 ? self.state.fromMonth + '/' + self.state.fromDay + '/' + self.state.fromYear : null;
            newGoalForm.toDate = null;
            self.props.editNewGoal(newGoalForm);
        });
    }

    selectFromMonth(month) {
        let self = this;
        let fromDayList = this.props.calendarDates[this.props.newGoalForm.timeFrame.toLowerCase()].start[this.state.fromYear][month];
        this.setState({
            fromMonth: month,
            fromDay: fromDayList.length === 1 ? fromDayList[0] : null,
            toYear: null,
            toMonth: null,
            toDay: null
        }, () => {
            let newGoalForm = self.props.newGoalForm;
            newGoalForm.fromDate = fromDayList.length === 1 ? self.state.fromMonth + '/' + self.state.fromDay + '/' + self.state.fromYear : null;
            newGoalForm.toDate = null;
            self.props.editNewGoal(newGoalForm);
        });
    }

    selectFromDay(day) {
        let self = this;
        this.setState({
            fromDay: day,
            toYear: null,
            toMonth: null,
            toDay: null
        }, () => {
            let newGoalForm = self.props.newGoalForm;
            newGoalForm.fromDate = self.state.fromMonth + '/' + self.state.fromDay + '/' + self.state.fromYear;
            newGoalForm.toDate = null;
            self.props.editNewGoal(newGoalForm);
        });
    }

    selectToYear(year) {
        let self = this;
        let toMonthList = Object.keys(this.props.calendarDates[this.props.newGoalForm.timeFrame.toLowerCase()].end[year]);
        let toDayList = [];
        if (toMonthList.length === 1) {
            toDayList = this.props.calendarDates[this.props.newGoalForm.timeFrame.toLowerCase()].end[year][toMonthList[0]];
        }
        this.setState({
            toYear: year,
            toMonth: toMonthList.length === 1 ? toMonthList[0] : null,
            toDay: toMonthList.length === 1 && toDayList.length === 1 ? toDayList[0] : null,
        }, () => {
            let newGoalForm = self.props.newGoalForm;
            newGoalForm.toDate = toMonthList.length === 1 && toDayList.length === 1 ? self.state.toMonth + '/' + self.state.toDay + '/' + self.state.toYear : null;
            self.props.editNewGoal(newGoalForm);
        });
    }

    selectToMonth(month) {
        let self = this;
        let toDayList = this.props.calendarDates[this.props.newGoalForm.timeFrame.toLowerCase()].end[this.state.toYear][month];
        this.setState({
            toMonth: month,
            toDay: toDayList.length === 1 ? toDayList[0] : null
        }, () => {
            let newGoalForm = self.props.newGoalForm;
            newGoalForm.toDate = toDayList.length === 1 ? self.state.toMonth + '/' + self.state.toDay + '/' + self.state.toYear : null;
            self.props.editNewGoal(newGoalForm);
        });
    }

    selectToDay(day) {
        let self = this;
        this.setState({
            toDay: day
        }, () => {
            let newGoalForm = self.props.newGoalForm;
            newGoalForm.toDate = self.state.toMonth + '/' + self.state.toDay + '/' + self.state.toYear;
            self.props.editNewGoal(newGoalForm);
        });
    }

    generateSlides() {

        let gForm = this.props.newGoalForm;

        let locationMap = this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
            let key = e.name;
            if (!r[key]) {
                r[key] = e.locationID;
            }
            return r;
        }, {});
        let locationMapReverse = this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
            let key = e.locationID;
            if (!r[key]) {
                r[key] = e.name;
            }
            return r;
        }, {});

        let userMapReverse = this.props.users.reduce((r, e) => {

            let key = e.userId;
            if (!r[key]) {
                r[key] = e.fullName;
            }

            return r;
        }, {});
        let locationUsersGrouping = this.props.users.reduce((r, e) => {

            let key = e.locationId;
            if (!r[key]) {
                r[key] = [e.fullName];
            } else {
                r[key].push(e.fullName);
            }

            return r;
        }, {});

        let kpiMapReverse = this.props.reportKPIs.reduce((r, e) => {

            let key = e.reportKpiId;
            if (!r[key]) {
                r[key] = { name: e.name, type: e.type };
            }

            return r;
        }, {});
        let kpiGrouping = this.props.reportKPIs.reduce((r, e) => {

            let key = e.kpiType === 'BLAST' ? 'location' : 'employee';
            if (!r[key]) {
                r[key] = [e.name];
            } else {
                r[key].push(e.name);
            }

            return r;
        }, {});

        let slidesJsx = [];
        let slideStyles = [];
        for (var i = 0; i < 6; i++) {
            if (this.state.slideNumber < i) {
                slideStyles.push({ left: '100vw', opacity: '0' });
            } else if (this.state.slideNumber > i) {
                slideStyles.push({ left: '-100vw', opacity: '0' });
            } else {
                slideStyles.push({ opacity: '1' });
            }

            switch (i) {
                case 0: slideStyles[0].height = '26rem';
                    break;
                case 1: slideStyles[1].height = '18rem';
                    break;
                case 2: slideStyles[2].height = '21rem';
                    break;
                case 3: slideStyles[3].height = '10rem'; slideStyles[3].overflow = 'hidden';
                    break;
                case 4: slideStyles[4].height = '10rem'; slideStyles[4].overflow = 'hidden';
                    break;
                case 5: slideStyles[5].height = '15.5rem'; slideStyles[5].overflow = 'hidden';
                    break;
            }
        }

        // Scope
        let caOptionClass = gForm.scope != 'ClientAccount' ? 'gc-scope-button' : 'gc-scope-button gc-button--active';
        let lOptionClass = gForm.scope != 'Location' ? 'gc-scope-button' : 'gc-scope-button gc-button--active';
        let uOptionClass = gForm.scope != 'User' ? 'gc-scope-button' : 'gc-scope-button gc-button--active';
        let caIconClass = gForm.scope === 'ClientAccount' ?
            'material-icons gc-scope-icon gc-icon--active' : 'material-icons gc-scope-icon gc-scope-icon--left';
        let lIconClass = gForm.scope === 'Location' ?
            'material-icons gc-scope-icon gc-icon--active' :
            (gForm.scope === 'User' ? 'material-icons gc-scope-icon gc-scope-icon--left' : 'material-icons gc-scope-icon gc-scope-icon--right');
        let uIconClass = gForm.scope === 'User' ?
            'material-icons gc-scope-icon gc-icon--active' : 'material-icons gc-scope-icon gc-scope-icon--right';
        slidesJsx.push((
            <div className={"gc-slide"} style={slideStyles[0]}>
                <div className={caIconClass}>location_city</div>
                <div className={lIconClass}>store_mall_directory</div>
                <div className={uIconClass}>person</div>
                <div className="gc-question scope">This goal is targeting a(n)...</div>
                <div className={caOptionClass} onClick={this.selectScope.bind(null, 'ClientAccount')}>Account</div>
                <div className={lOptionClass} onClick={this.selectScope.bind(null, 'Location')}>Location</div>
                <div className={uOptionClass} onClick={this.selectScope.bind(null, 'User')}>Employee</div>
            </div>
        ));

        // Location/Employee Names
        let locationStringList = _.sortBy(Object.keys(locationMap), (obj) => { return obj });
        let locationIconClass = 'material-icons gc-locationuser-icon';
        let userIconClass = 'material-icons gc-locationuser-icon';
        let userQuestionClass = 'gc-question user';
        if (gForm.locationId != null) {
            locationIconClass += ' active';
        }
        if (gForm.scope === 'User') {
            if (gForm.userId != null) {
                userIconClass += ' active';
            }
            locationIconClass += ' left';
            userIconClass += ' right';

            if (gForm.locationId != null) {
                slideStyles[1].height = '24rem';
            } else {
                userQuestionClass += ' hidden';
            }

        } else if (gForm.scope === 'Location') {
            userIconClass += ' hidden';
        }
        slidesJsx.push((
            <div className={"gc-slide"} style={slideStyles[1]}>
                <div className={locationIconClass}>store_mall_directory</div>
                <div className={userIconClass}>person</div>
                <div className={"gc-question location"}>{gForm.scope === 'Location' ?
                    "This goal is for the location..." :
                    "This goal is for the employee working at..."
                }</div>
                <ZSelectField
                    id="gc-location-select-field"
                    placeholder="Select Location"
                    defaultValue={null}
                    className="gc-z-selector location"
                    menuItems={locationStringList}
                    onChange={this.selectLocation}
                    value={locationMapReverse[gForm.locationId]}
                    activeColor="rgba(0, 126, 181, 1)"
                    isBlocked
                />
                {
                    gForm.scope === 'User' ?
                        <div className={userQuestionClass}>And the employee is...</div>
                        :
                        null
                }
                {
                    gForm.scope === 'User' ?
                        <ZSelectField
                            id="gc-location-select-field"
                            placeholder="Select Employee"
                            defaultValue={null}
                            className={gForm.locationId != null ? "gc-z-selector user" : "gc-z-selector user hidden"}
                            menuItems={_.sortBy(locationUsersGrouping[gForm.locationId], (obj) => { return obj })}
                            onChange={this.selectUser}
                            value={userMapReverse[gForm.userId]}
                            activeColor="rgba(0, 126, 181, 1)"
                            isBlocked
                        />
                        :
                        null
                }
            </div>
        ));

        // Name/Description
        slidesJsx.push((
            <div className={"gc-slide"} style={slideStyles[2]}>
                <div className="gc-hello-name-container">
                    <div className="hello-hello">HELLO</div>
                    <div className="hello-sub">The name of my goal is...</div>
                    <div className="hello-name-container">
                        <TextField
                            id="goal-name-textfield"
                            placeholder={"Goal Name"}
                            className={"gc-text-input name"}
                            value={gForm.name}
                            onChange={this.changeName}
                        />
                    </div>
                </div>
                <div className="gc-question description">
                    {"And I would describe my goal as..."}
                </div>
                <TextField
                    id="goal-description-textfield"
                    placeholder={"Description"}
                    className={"gc-text-input description"}
                    value={gForm.description}
                    onChange={this.changeDescription}
                />
            </div>
        ));

        // Metric Name / HighLow / Type / Value
        let activeKpiList = gForm.scope === 'User' ? kpiGrouping.employee : kpiGrouping.location;
        let activeKpiName = kpiMapReverse[gForm.reportKPIId] != undefined ? kpiMapReverse[gForm.reportKPIId].name : '';
        let activeKpiType = kpiMapReverse[gForm.reportKPIId] != undefined ? kpiMapReverse[gForm.reportKPIId].type : '';

        let hidePhases = [true, true, true];
        let mhltvIconActiveList = [false, false, false, false]
        if (gForm.reportKPIId != null) {
            hidePhases[0] = false;
            mhltvIconActiveList[0] = true;
            slideStyles[3].height = '17rem';
        }
        if (gForm.useUnder != null) {
            hidePhases[1] = false;
            mhltvIconActiveList[1] = true;
            slideStyles[3].height = '25rem';
        }
        if (gForm.type != null) {
            hidePhases[2] = false;
            mhltvIconActiveList[2] = true;
            slideStyles[3].height = '30rem';
        }
        if (gForm.value.trim() != '' && (gForm.value.match(/^\d+\.\d+$/) || gForm.value.match(/^-{0,1}\d+$/))) {
            mhltvIconActiveList[3] = true;
        }

        let hideStyle = { opacity: '0', pointerEvents: 'none' };

        let highOptionClass = gForm.useUnder != null && gForm.useUnder === false ? 'gc-highlow-button gc-button--active' : 'gc-highlow-button';
        let lowOptionClass = gForm.useUnder != null && gForm.useUnder === true ? 'gc-highlow-button gc-button--active' : 'gc-highlow-button';
        let highOptionStyle = { left: '1rem' };
        let lowOptionStyle = { left: '50%' };
        if (hidePhases[0]) {
            highOptionStyle.opacity = '0';
            highOptionStyle.pointerEvents = 'none';
            lowOptionStyle.opacity = '0';
            lowOptionStyle.pointerEvents = 'none';
        }

        let numOptionClass = gForm.type != null && gForm.type === '#' ? 'gc-type-button gc-button--active' : 'gc-type-button';
        let percOptionClass = gForm.type != null && gForm.type === '%' ? 'gc-type-button gc-button--active' : 'gc-type-button';
        let numOptionStyle = { top: '19.5rem' };
        let percOptionStyle = { top: '21.5rem' };
        if (hidePhases[1]) {
            numOptionStyle.opacity = '0';
            numOptionStyle.pointerEvents = 'none';
            percOptionStyle.opacity = '0';
            percOptionStyle.pointerEvents = 'none';
        }

        slidesJsx.push((
            <div className={"gc-slide"} style={slideStyles[3]}>
                <div className={"material-icons gc-mhltv-icon spot1" + (mhltvIconActiveList[0] ? ' active' : '')}>equalizer</div>
                <div className={"material-icons gc-mhltv-icon spot2" + (mhltvIconActiveList[1] ? ' active' : '')} style={gForm.useUnder ? hideStyle : {}}>trending_up</div>
                <div className={"material-icons gc-mhltv-icon spot2" + (mhltvIconActiveList[1] ? ' active' : '')} style={!gForm.useUnder ? hideStyle : {}}>trending_down</div>
                <div className={"gc-mhltv-icon spot3" + (mhltvIconActiveList[2] ? ' active' : '')} style={gForm.type === '%' ? hideStyle : {}}>#</div>
                <div className={"gc-mhltv-icon spot3" + (mhltvIconActiveList[2] ? ' active' : '')} style={gForm.type != '%' ? hideStyle : {}}>%</div>
                <div className={"material-icons gc-mhltv-icon spot4" + (mhltvIconActiveList[3] ? ' active' : '')}>attach_money</div>

                <div className="gc-question metric">{"Which metric does this goal use?"}</div>
                <div className="gc-metric-selector-container">
                    <ZSelectField
                        id="gc-metric-select-field"
                        placeholder="Select Metric"
                        defaultValue={null}
                        className={"gc-z-selector metric"}
                        menuItems={activeKpiList}
                        onChange={this.selectMetric}
                        value={activeKpiName === '' ? null : activeKpiName}
                        activeColor="rgba(0, 126, 181, 1)"
                        isBlocked
                    />
                </div>

                <div style={hidePhases[0] ? hideStyle : {}} className="gc-question highlow">{"Is it better for " + activeKpiName + " to be higher or lower?"}</div>
                <div className={highOptionClass} style={highOptionStyle} onClick={this.selectHighLow.bind(null, false)}>{"Higher"}</div>
                <div className={lowOptionClass} style={lowOptionStyle} onClick={this.selectHighLow.bind(null, true)}>{"Lower"}</div>

                <div style={hidePhases[1] ? hideStyle : {}} className="gc-question type">{"My goal is to get " + activeKpiName + "..."}</div>
                <div className={numOptionClass} style={numOptionStyle} onClick={this.selectType.bind(null, '#')}>
                    {"..." + (gForm.useUnder ? 'under' : 'over') + " a specific number"}
                </div>
                <div className={percOptionClass} style={percOptionStyle} onClick={this.selectType.bind(null, '%')}>
                    {"...a percentage " + (gForm.useUnder ? 'under' : 'over') + " last year"}
                </div>

                <div style={hidePhases[2] ? hideStyle : {}} className="gc-question value">{
                    gForm.type === '#' ?
                        "The goal is to get " + activeKpiName + (gForm.useUnder ? ' under' : ' over') :
                        "The goal is to get " + activeKpiName
                }</div>
                <div style={hidePhases[2] ? hideStyle : {}} className="gc-question value2">{gForm.type === '#' && activeKpiType === 'MNY' ? "$" : ""}</div>
                <TextField
                    id="goal-value-textfield"
                    placeholder={"X"}
                    className={"gc-text-input value " + (gForm.type === '%' ? "perc" : "num") + (activeKpiType === 'PCT' ? " pct" : "")}
                    style={hidePhases[2] ? hideStyle : {}}
                    value={gForm.value}
                    onChange={this.changeValue}
                />
                <div style={hidePhases[2] ? hideStyle : {}} className="gc-question value3">{gForm.type === '#' && activeKpiType === 'PCT' ? "%" : ""}</div>
                <div style={hidePhases[2] ? hideStyle : {}} className="gc-question value4">{gForm.type === '%' ? "% " + (gForm.useUnder ? 'under' : 'over') + " last year" : ""}</div>
            </div>
        ));

        // Time Frame / Start Date / #Consecutive &| End Date
        let timeIconActiveList = [false, false, false];
        let hideCal = true;
        let hideToFromLabel = true;
        if (gForm.timeFrame != null) {
            timeIconActiveList[0] = true;
            slideStyles[4].height = '30.5rem';
            hideCal = false;
            hideToFromLabel = false;
        }
        if (gForm.fromDate != null) {
            timeIconActiveList[1] = true;
        }
        if (gForm.toDate != null) {
            timeIconActiveList[2] = true;
            slideStyles[4].height = '25.5rem';
            hideToFromLabel = true;
        }

        // let calendarJsxObj = this.generateDateObjects();
        let calendarJsxObj = this.gcManager.generateDateObjects(gForm, this.props.calendarDates, this);

        slidesJsx.push((
            <div className={"gc-slide"} style={slideStyles[4]}>
                <div className={"material-icons gc-time-icon spot1" + (timeIconActiveList[0] ? ' active' : '')}>query_builder</div>
                <div className={"material-icons gc-time-icon spot2" + (timeIconActiveList[1] ? ' active' : '')}>calendar_today</div>
                <div className={"material-icons gc-time-icon spot2" + (timeIconActiveList[1] ? ' active' : '')} style={{ transform: 'rotateY(180deg)' }}>arrow_right_alt</div>
                <div className={"material-icons gc-time-icon spot3" + (timeIconActiveList[2] ? ' active' : '')}>calendar_today</div>
                <div className={"material-icons gc-time-icon spot3" + (timeIconActiveList[2] ? ' active' : '')}>arrow_right_alt</div>

                <div className="gc-question time">{"The time period for my goal is..."}</div>
                <div className={"gc-time-text" + (gForm.timeFrame === 'Day' ? ' active' : '')}>{"Daily"}</div>
                <div className={"gc-time-text" + (gForm.timeFrame === 'Week' ? ' active' : '')}>{"Weekly"}</div>
                <div className={"gc-time-text" + (gForm.timeFrame === 'Month' ? ' active' : '')}>{"Monthly"}</div>
                <div className={"gc-time-text" + (gForm.timeFrame === 'Quarter' ? ' active' : '')}>{"Quarterly"}</div>
                <div className={"gc-time-text" + (gForm.timeFrame === 'Year' ? ' active' : '')}>{"Yearly"}</div>

                <div className={"gc-time-button d" + (gForm.timeFrame != null ? ' active' : '') + (gForm.timeFrame === 'Day' ? ' gc-button--active' : '')}
                    onClick={this.changeTimePeriod.bind(null, 'Day')}>D</div>
                <div className={"gc-time-button w" + (gForm.timeFrame != null ? ' active' : '') + (gForm.timeFrame === 'Week' ? ' gc-button--active' : '')}
                    onClick={this.changeTimePeriod.bind(null, 'Week')}>W</div>
                <div className={"gc-time-button m" + (gForm.timeFrame != null ? ' active' : '') + (gForm.timeFrame === 'Month' ? ' gc-button--active' : '')}
                    onClick={this.changeTimePeriod.bind(null, 'Month')}>M</div>
                <div className={"gc-time-button q" + (gForm.timeFrame != null ? ' active' : '') + (gForm.timeFrame === 'Quarter' ? ' gc-button--active' : '')}
                    onClick={this.changeTimePeriod.bind(null, 'Quarter')}>Q</div>
                <div className={"gc-time-button y" + (gForm.timeFrame != null ? ' active' : '') + (gForm.timeFrame === 'Year' ? ' gc-button--active' : '')}
                    onClick={this.changeTimePeriod.bind(null, 'Year')}>Y</div>

                <div className="gc-tofrom-label-container">
                    <div style={hideToFromLabel ? hideStyle : {}} className={"gc-from-label" + (calendarJsxObj.phase >= 1 && calendarJsxObj.phase < 4 ? ' active' : '')}>{"Start"}</div>
                    <div style={hideToFromLabel ? hideStyle : {}} className={"gc-to-label" + (calendarJsxObj.phase >= 4 && calendarJsxObj.phase < 7 ? ' active' : '')}>{"End"}</div>
                </div>

                <div style={hideCal ? hideStyle : {}} className={"gc-calendar-container" + (calendarJsxObj.phase === 1 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.fromYear}
                </div>
                <div style={hideCal ? hideStyle : {}} className={"gc-calendar-container" + (calendarJsxObj.phase === 2 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.fromMonth}
                </div>
                <div style={hideCal ? hideStyle : {}} className={"gc-calendar-container" + (calendarJsxObj.phase === 3 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.fromDay}
                </div>
                <div style={hideCal ? hideStyle : {}} className={"gc-calendar-container" + (calendarJsxObj.phase === 4 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.toYear}
                </div>
                <div style={hideCal ? hideStyle : {}} className={"gc-calendar-container" + (calendarJsxObj.phase === 5 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.toMonth}
                </div>
                <div style={hideCal ? hideStyle : {}} className={"gc-calendar-container" + (calendarJsxObj.phase === 6 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.toDay}
                </div>

                {/* <div className="gc-question calconfirm" style={calendarJsxObj.phase != 7 ? hideStyle : {}}>
                    {"My goal is a repeating " + (gForm.timeFrame === 'Day' ? 'Daily' : (gForm.timeFrame + 'ly')) + ' goal beginning'}
                </div> */}
                <div className="gc-question calconfirm" style={calendarJsxObj.phase != 7 ? hideStyle : {}}>
                    {"My goal repeats every " + (gForm.timeFrame != null ? gForm.timeFrame.toLowerCase() : '') + " beginning"}
                </div>
                <div className="gc-question calconfirm2" style={calendarJsxObj.phase != 7 ? hideStyle : {}}>
                    {"and ending"}
                </div>
            </div>
        ));

        // Review

        let monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        if (this.state.slideNumber === 5) {
            slideStyles[5].height = '35.5rem';
        }

        slidesJsx.push((
            <div className={"gc-slide"} style={slideStyles[5]}>
                <div className={"gc-review-header scope"}>
                    <div className={"gc-review-header-text"}>Scope</div>
                    <div className={"material-icons gc-review-header-edit"} onClick={this.setSlide.bind(null, 0)}>edit</div>
                    <div className={"gc-review-underheader"}>
                        {gForm.scope === 'ClientAccount' ? 'Account Wide' : (gForm.scope === 'Location' ? 'Location Wide' : (gForm.scope === 'User' ? 'Specific Employee' : ''))}
                    </div>
                </div>

                <div className={"gc-review-header target"}>
                    <div className={"gc-review-header-text"}>Target</div>
                    <div className={"material-icons gc-review-header-edit"} onClick={this.setSlide.bind(null, 1)}>edit</div>
                    <div className={"gc-review-underheader"}>{"Location: " + (gForm.locationId != null ? locationMapReverse[gForm.locationId] : 'N/A')}</div>
                    <div className={"gc-review-underheader"}>{"Employee: " + (gForm.userId != null ? userMapReverse[gForm.userId] : 'N/A')}</div>
                </div>
                <div className={"gc-review-header identity"}>
                    <div className={"gc-review-header-text"}>Identity</div>
                    <div className={"material-icons gc-review-header-edit"} onClick={this.setSlide.bind(null, 2)}>edit</div>
                    <div className={"gc-review-underheader"}>{'Name: ' + gForm.name}</div>
                    <div className={"gc-review-underheader"}>{'Description: ' + gForm.description}</div>
                </div>
                <div className={"gc-review-header details"}>
                    <div className={"gc-review-header-text"}>Details</div>
                    <div className={"material-icons gc-review-header-edit"} onClick={this.setSlide.bind(null, 3)}>edit</div>
                    <div className={"gc-review-underheader"}>
                        {
                            gForm.type === '#' ?
                                "The goal is to get " + activeKpiName + (gForm.useUnder ? ' under ' : ' over ') + (activeKpiType === 'MNY' ? "$" : "") + gForm.value + (activeKpiType === 'PCT' ? "%" : "")
                                :
                                "The goal is to get " + activeKpiName + " " + gForm.value + "% " + (gForm.useUnder ? 'under' : 'over') + " last year"
                        }
                    </div>
                </div>
                <div className={"gc-review-header time"}>
                    <div className={"gc-review-header-text"}>Time</div>
                    <div className={"material-icons gc-review-header-edit"} onClick={this.setSlide.bind(null, 4)}>edit</div>
                    <div className={"gc-review-underheader"}>
                        {'The goal repeats every ' + (gForm.timeFrame != null ? gForm.timeFrame.toLowerCase() : '') + " beginning " +
                            monthList[parseInt(this.state.fromMonth) - 1] + " " + this.state.fromDay + ", " + this.state.fromYear + " and ending " +
                            monthList[parseInt(this.state.toMonth) - 1] + " " + this.state.toDay + ", " + this.state.toYear}
                    </div>
                </div>
            </div>
        ));


        return slidesJsx;
    }

    setSlide(num) {
        if (num === 1 && this.props.newGoalForm.scope === 'ClientAccount') {
            num = 0;
        }
        this.setState({ slideNumber: num });
    }

    nextSlide() {

        if (this.props.newGoalForm.scope === 'ClientAccount' && this.state.slideNumber === 0) {
            this.setState({ slideNumber: 2 });
        } else if (this.state.slideNumber != 5) {
            this.setState({ slideNumber: ++this.state.slideNumber });
        }
    }

    backSlide() {
        if (this.props.newGoalForm.scope === "ClientAccount" && this.state.slideNumber === 2) {
            this.setState({ slideNumber: 0 });
        } else if (this.state.slideNumber != 0) {
            this.setState({ slideNumber: --this.state.slideNumber });
        }
    }

    cancel() {
        let self = this;
        zconfirm("Are you sure you want to cancel?", () => {
            this.setState({
                fromYear: null,
                fromMonth: null,
                fromDay: null,
                toYear: null,
                toMonth: null,
                toDay: null
            }, () => {
                self.props.cancelNewGoal();
            });
        });
    }

    finish() {
        let self = this;
        let toDateIndex = parseInt(this.state.toYear + this.state.toMonth + this.state.toDay);
        let nowDateIndex = parseInt(moment().format('YYYYMMDD'));
        if (toDateIndex < nowDateIndex) {
            zconfirm("I noticed your new goal ends in the past. Are you sure you want to continue?", () => {
                this.setState({
                    fromYear: null,
                    fromMonth: null,
                    fromDay: null,
                    toYear: null,
                    toMonth: null,
                    toDay: null
                }, () => {
                    setTimeout(() => {
                        self.state.slideNumber = 0; // I do not want the UI to update yet, will update on the next function call
                    }, 500);
                    self.props.finishNewGoal();
                });
            });
        } else {
            this.setState({
                fromYear: null,
                fromMonth: null,
                fromDay: null,
                toYear: null,
                toMonth: null,
                toDay: null
            }, () => {
                setTimeout(() => {
                    self.state.slideNumber = 0; // I do not want the UI to update yet, will update on the next function call
                }, 500);
                self.props.finishNewGoal();
            });
        }
    }

    render() {

        let slidesJsx = this.generateSlides();

        let formValidSlide = this.validateForm();
        let formValidFinal = this.validateFormFinal();

        let backStyle = {}
        let cancelStyle = { top: '-4.2rem', pointerEvents: 'none', opacity: '0' }
        if (this.state.slideNumber === 0) {
            backStyle = { top: '4.2rem', pointerEvents: 'none', opacity: '0' }
            cancelStyle = {}
        }
        let nextStyle = {}
        let finishStyle = { top: '-4.2rem', pointerEvents: 'none', opacity: '0' }
        if (this.state.slideNumber === 5) {
            nextStyle = { top: '4.2rem', pointerEvents: 'none', opacity: '0' }
            finishStyle = {}
        }
        if (this.state.slideNumber < 5 && !formValidSlide) {
            nextStyle.opacity = '0.5';
        }
        if (this.state.slideNumber === 5 && !formValidFinal) {
            finishStyle.opacity = '0.5';
        }

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className="gc-new-slide-container">
                    {slidesJsx}
                </div>
                <div className="gc-next-bar">
                    <div className="gc-back-button" style={backStyle} onClick={this.backSlide}>BACK</div>
                    <div className="gc-back-button" style={cancelStyle} onClick={this.cancel}>CANCEL</div>
                    <div className="gc-next-button" style={nextStyle} onClick={formValidSlide ? this.nextSlide : null}>NEXT</div>
                    <div className="gc-next-button" style={finishStyle} onClick={formValidFinal ? this.finish : null}>FINISH</div>
                </div>
            </div>
        );
    }
}